import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface AgentDetailRowProps {
    label: string;
    alignToBadges?: boolean;
    className?: string;
    children: ReactNode;
}

export function AgentDetailRow({
    label,
    alignToBadges,
    className,
    children
}: AgentDetailRowProps) {
    return (
        <div
            className={cn(
                'items-start gap-3 grid grid-cols-[4rem_1fr] py-2.5 border-border border-b last:border-b-0',
                className
            )}
        >
            <span
                className={cn(
                    'text-muted-foreground text-sm',
                    alignToBadges ? 'leading-7' : 'leading-5'
                )}
            >
                {label}
            </span>
            <div className="min-w-0">{children}</div>
        </div>
    );
}
